import { BasicModalLoaderPayload } from './basic-modal-loader-payload';

/**
 * Created by 310293471 on 19/03/2018.
 */
export class WarningModalLoaderPayload extends BasicModalLoaderPayload {
  public approveBtn?: string;

  constructor(title: string, content?: string, approveBtnText?: string) {
    super(title, content);
    this.approveBtn = approveBtnText;
    this.backdropAllowed = false;
  }

  static builder() {
    return new this(null);
  }

  setApproveButtonText(text: string) {
    this.approveBtn = text;
    return this;
  }
}
